import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { TextField } from "@rmwc/textfield";
import {
  submitReportIssue,
  setScreenShot,
  handleDescription,
} from "../../action/index.js";
import * as validate from "../../Components/Modals/validations";
import { const_var } from "../../redux/reducers/reducer.js";
import AnimButton from "../Button/AnimButton.js";

class ReportIssue extends React.Component {
  constructor(props) {
    super(props);
  }

  handleClick = () => {
    this.props.handleDescription("");
    this.props.setScreenShot("");
    this.props.handleClose();
    setTimeout(() => {
      if (this.props.const_var.isShowCompare == true) {
        document.querySelector("body").classList.add("modal-open");
      }
    }, 500);
  };
  submit = async () => {
    validate.onSubmitReportIssueDesc(const_var.reportDesc, "reportIssue");
    if (const_var.reportDesc != "" && (this.props.const_var.displayerrorMessage.reportIssue == "" || this.props.const_var.displayerrorMessage.reportIssue == undefined)) {
      this.props.submitReportIssue(
        const_var.reportDesc,
        window.location.href,
        const_var.setScreenshot
      );
    } else {
      this.setState({
        showLoader: false,
      });
    }
  };
  handleChange = (e) => {
    validate.onSubmitReportIssueDesc(e.target.value, "reportIssue");
    this.props.handleDescription(e.target.value);
  };
  reEnterIssue = () => {
    this.props.handleDescription("");
    this.props.submitReportIssue();
  };

  custom(){
    document.getElementsByClassName("modal")[0].style.transform = "scale(0)"
    document.getElementsByClassName("modal")[0].style.transition = "0.6s"
    setTimeout(() => {
       this.handleClick()
    },500)
 }

  render() {
    return (
      <Modal
        centered
        show={this.props.show}
        dialogClassName={`alert-modal react-modal resolve-err-modal ${
          const_var.reportIssueID || const_var.errormsg ? "no-img" : "no-img"
        } ${
          const_var.setScreenshot == undefined || const_var.setScreenshot == ""
            ? "loader-show"
            : ""
        } ${
          const_var.showReportLoading && const_var.reportIssueID == ""
            ? "form-submiting"
            : ""
        }`}
        backdrop="static"
        keyboard={false}
        onHide={(e) => this.handleClick()}
        className="report-err-mdal-dialog"
      >
        {const_var.setScreenshot != undefined && const_var.setScreenshot != "" ? (
          <button className="close" onClick={(e) => this.custom()}>
            <span className="icon-close"></span>
          </button>
        ) : null}
        <Modal.Body>
          <>
            {const_var.setScreenshot == undefined || const_var.setScreenshot == "" ? (
              <div
                className={
                  const_var.setScreenshot && const_var.setScreenshot != ""
                    ? " spinner-loader"
                    : "spinner-loader spinner-active"
                }
              >
                <div className="spinner-loader">
                  <div className="spinner"></div>
                </div>

                <div className="spinner-content">
                  <h6 className="spinner-title">Please Wait...</h6>
                  <div className="spinner-text">
                      Hey, We are capturing a screenshot of your screen to include with the issue report. This will enhance our team’s understanding of the problem, and accelerate the issue resolution process.
                  </div>
                </div>
                <div className="spinner-bottom">
                    Thank you for your patience and cooperation!
                </div>
              </div>
            ) : (
              <>
                {const_var.errormsg ? (
                  <>
                    <h5 className="modal-title mb-3">Warning!!</h5>
                    <div className="row">
                      <div className="col-12">
                        <p>{const_var.errormsg}</p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <p>
                          or{" "}
                          <a
                            href
                            onClick={() => this.reEnterIssue()}
                            style={{ textDecoration: "underline" }}
                          >
                            Go Back
                          </a>
                          .
                        </p>
                      </div>
                    </div>
                  </>
                ) : const_var.reportIssueID ? (
                  <div className="success-container">
                    <div className="success-badge">
                      Your error reported successfully!
                      <div>
                        <i className="icon-checkmark-ico"></i>
                      </div>
                    </div>
                    <div className="success-content">
                      Thank You for contacting Sensei CRM. We have created
                      your ticket with this ID-{const_var.reportIssueID}
                    </div>
                    {const_var.loginSession == true && (
                      <div className="success-footer">
                        Please{" "}
                        <a
                          href={const_var.crmSetting.navigation_url.report_error + "/" + const_var.ticketId}
                          target="_blank"
                          style={{ textDecoration: "underline" }}
                        >
                          Click Here
                        </a>{" "}
                        to check your ticket's status
                      </div>
                    )}
                  </div>
                ) : (
                  <>
                    {
                      <>
                        <div className="row">
                          <div className="col-12">
                            <p className='report-title'>
                              We captured the screenshot, please add additional
                              details of the error below -
                            </p>
                          </div>
                        </div>
                        <div>
                          <div
                            className={`floating-label-input ${
                              (this.props.const_var.displayerrorMessage
                                .reportIssue != undefined &&
                                this.props.const_var.displayerrorMessage
                                  .reportIssue != "") ||
                              const_var.errormsg
                                ? "invalid-input"
                                : ""
                            }`}
                          >
                            <TextField
                              textarea
                              name={"reportIssue"}
                              // value={const_var.reportDesc}
                              fullwidth
                              rows={4}
                              minLength={5}
                              maxLength={1000}
                              onChange={(e) => this.handleChange(e)}
                              placeholder="Add more details to help us solve this quickly..."
                              characterCount
                            />
                            {this.props.const_var.displayerrorMessage
                              .reportIssue != undefined && (
                                <>
                                  <span className="error-icon icon-info-ico"></span>
                                  <div
                                    className="errorMessage"
                                    id="reportIssueErrorMessage"
                                  >
                                    {
                                      this.props.const_var.displayerrorMessage
                                        .reportIssue
                                    }
                                  </div>
                                </>
                            )}
                            {const_var.errormsg && (
                              <div className="errorMessage">
                                {const_var.errormsg}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12 ">
                            <div className="alert-footer">
                              <button
                                className="btn btn-secondary"
                                onClick={(e) => this.custom()}
                              >
                                CANCEL
                              </button>
                              <button
                                className="btn btn-primary"
                                onClick={this.submit}
                              >
                                SUBMIT
                              </button>
                            </div>
                          </div>
                        </div>
                      </>
                    }
                  </>
                )}
              </>
            )}
          </>
        </Modal.Body>
        {!const_var.reportIssueID &&
          !const_var.errormsg &&
          const_var.setScreenshot &&
          const_var.setScreenshot != "" && (
            <Modal.Footer>
              Note : It will create a new support ticket under your name. You can view all the updates on this ticket from My Tickets.
            </Modal.Footer>
          )}
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return { ...state.reducer, ...state.orderReducer };
};

const mapDispatchToProps = {
  submitReportIssue,
  setScreenShot,
  handleDescription,
};
export default connect(mapStateToProps, mapDispatchToProps)(ReportIssue);
